import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useTitle} from '../dashboard/TitleContext';
import {useSnackbar} from '../../util/SnackbarProvider';
import cloudStorageFileService from "../../services/CloudStorageFileService";
import authService from "../../services/AuthService";
import axios from "axios";
import {API_URL} from "../../App";
import productProjectService from "../../services/ProductProjectService";
import ProductProjectEditorTemplate from "./ProductProjectEditorTemplate";
import productProjectIterationService from "../../services/ProductProjectIteratlonService";
import taskTypeService from "../../services/TaskTypeService";
import productService from "../../services/ProductService";
import {useLocalNavigation} from "../dashboard/LocalNavigationContext";
import {Ballot, History, MoveDown, Storage} from "@mui/icons-material";
import {getFileUrl} from "../../services/FileService";

const TEMPORARY_TP_STATE_LOCAL_STORAGE = "temporary-tp-state-local-storage";

const ProductProjectEditor = () => {

    const urlParts = window.location.pathname.split('/')
    const id = urlParts[3] === 'create' ? undefined : urlParts[3]

    useTitle([
        {name: 'Termék Projekt Lista', url: '/dashboard/product-projects'},
        {name: 'Termék Projekt', url: '/dashboard/product-projects/' + (id || 'create')},
    ])

    useLocalNavigation([
        {title: 'Alraktárak', url: '/dashboard/storage/substorages', icon: <Storage/>},
        {title: 'Termékek Mozgatása', url: '/dashboard/storage/move', icon: <MoveDown/>},
        {title: 'Raktár Történet', url: '/dashboard/storage/logs', icon: <History/>},
        {title: 'Feladatkörök', url: '/dashboard/task-types', icon: <Ballot/>},
    ])

    const [isDraft, setIsDraft] = useState(false)
    const [productProject, setProductProject] = useState(JSON.parse(localStorage.getItem(TEMPORARY_TP_STATE_LOCAL_STORAGE + '-' + id) || '{}'));
    const {sendAlertMessage} = useSnackbar()
    const [waitingForServer, setWaitingForServer] = useState(false)
    const [message, setMessage] = useState('')
    const navigate = useNavigate()
    const [chatMessage, setChatMessage] = useState('')

    useEffect(() => {
        if (!id) return
        if( productProject?.id) {
            setIsDraft(true)
            return
        }
        retrieveProductProject()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    function retrieveProductProject() {
        productProjectService.findById(id)
            .then(response => {
                const fixedTasks = response.taskTypes.map(task => ({
                    ...task,
                    product: task.product
                }));
                const fixedResponse = {
                    ...response,
                    taskTypes: fixedTasks
                };
                setProductProject(() => fixedResponse);
            })
            .catch(error => sendAlertMessage(error?.message || 'Termék projekt lekérése sikertelen', 'error'));
    }

    const [imgUrl, setImgUrl] = useState(null);
    const [loadingImage, setLoadingImage] = useState(false);
    useEffect(() => {
        if (!productProject?.picture?.id) return;
        setLoadingImage(true);
        let url;
        getFileUrl('', `/cloud-storage-files/${productProject.picture.id}`).then(u => {
            url = u;
            setImgUrl(u);
            setLoadingImage(false);
        });

        return () => {
            if (url) window.URL.revokeObjectURL(url); // cleanup
        };
    }, [productProject?.picture?.id]);

    const [taskTypes, setTaskTypes] = useState([]);
    useEffect(() => {
        taskTypeService.getSelectors()
            .then(response => setTaskTypes(response))
            .catch(error => console.error(error));
    }, []);

    const onChange = (e, v, n) => {
        const name = n || e.target.name
        const value = v || e.target.value
        setProductProject((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const onChangeCheckBox = (event) => {
        const {name, checked} = event.target;
        setProductProject((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };

    const onDateTimeChange = (newValue, name) => {
        setProductProject((prev) => ({
            ...prev,
            [name]: newValue,
        }));
    };

    const onChangeChatMessage = (event) => {
        setChatMessage(event.target.value);
    };

    const create = async (e) => {
        e.preventDefault();
        setWaitingForServer(true)
        const formData = new FormData();
        formData.append('request', new Blob([JSON.stringify(prepareRequest())], {type: "application/json"}));
        files.forEach((file) => {
            formData.append('files', file);
        });

        const headers = {'Authorization': 'Bearer ' + authService.getCurrentUser().accessToken};
        try {
            const response = await axios.post(API_URL + '/product-projects', formData, {headers: headers});
            if (response) {
                sendAlertMessage('Termék projekt sikeresen létrehozva')
                navigate(-1);
            }
        } catch (error) {
            sendAlertMessage(error?.response?.data?.message || 'Termék projekt létrehozása sikertelen', 'error')
        }
        setWaitingForServer(false)
    };

    const update = async (e) => {
        e.preventDefault();
        setWaitingForServer(true)
        const formData = new FormData();
        formData.append('request', new Blob([JSON.stringify(prepareRequest())], {type: "application/json"}));
        files.forEach((file) => {
            formData.append('files', file);
        });

        const headers = {'Authorization': 'Bearer ' + authService.getCurrentUser().accessToken};
        try {
            const response = await axios.patch(API_URL + '/product-projects/' + id, formData, {headers: headers});
            if (response) {
                sendAlertMessage('Termék projekt sikeresen mentve')
                retrieveProductProject()
                setFiles([])
            }
        } catch (error) {
            sendAlertMessage(error?.response?.data?.message || 'Termék projekt mentése sikertelen', 'error')
        }
        setWaitingForServer(false)
        localStorage.removeItem(TEMPORARY_TP_STATE_LOCAL_STORAGE + '-' + id);
        setIsDraft(false)
    };

    const del = (id) => {
        productProjectIterationService.delete(id)
            .then(() => {
                sendAlertMessage('Gyártási ciklus sikeresen törölve')
                retrieveProductProject()
            })
            .catch(error => sendAlertMessage(error?.message || 'Gyártási ciklus törlése sikertelen', 'error'))
    }

    const saveAsDraft = () => {
        if (!id) return
        localStorage.setItem(TEMPORARY_TP_STATE_LOCAL_STORAGE + '-' + id, JSON.stringify(productProject));
        sendAlertMessage('Piszkozat sikeresen mentve az eszközön')
        setIsDraft(true)
    }

    const deleteDraft = () => {
        if (!id) return
        localStorage.removeItem(TEMPORARY_TP_STATE_LOCAL_STORAGE + '-' + id);
        retrieveProductProject()
        sendAlertMessage('Piszkozat sikeresen törölve az eszközről')
        setIsDraft(false)
    }

    const prepareRequest = () => {
        const copy = structuredClone(productProject)
        copy.taskTypes?.forEach(item => {
            delete item.productList;
            item.products = item.products?.filter(productObject => productObject.product?.id !== null);
            if (item.product?.id == null) item.product = null
        });
        return copy
    }

    const removeDocumentName = (fileId) => {
        productProjectService.deleteFile(id, fileId)
            .then(() => {
                retrieveProductProject()
                sendAlertMessage('Fájl sikeresen törölve!')
            })
            .catch(error => sendAlertMessage(error.message, 'error'))
    };

    const updateFileDescription = (id, form) => {
        cloudStorageFileService.update(id, form)
            .then(() => {
                retrieveProductProject()
                sendAlertMessage('Fájl leírása sikeresen módosítva!')
            })
            .catch(error => sendAlertMessage(error.message, 'error'))
    }

    const convertExcelToProductList = async (excel, index, request) => {
        const formData = new FormData();
        formData.append('file', excel);
        formData.append('request', new Blob([JSON.stringify(request)], {type: "application/json"}));

        productService.convertExcelToProductList(formData)
            .then(response => {
                setProductProject(prev => {
                    const updatedTaskTypes = [...prev.taskTypes];
                    updatedTaskTypes[index] = {
                        ...updatedTaskTypes[index],
                        products: response
                    };
                    return {
                        ...prev,
                        taskTypes: updatedTaskTypes
                    };
                });
            })
            .catch(error => sendAlertMessage(error.message, 'error'))
    };

    const [files, setFiles] = useState([]);
    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
    };

    const handleRemoveFile = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const moveProductToAnotherTaskType = (index, j, directionUp) => {
        setProductProject(prevProject => {
            const taskTypes = [...prevProject.taskTypes];

            const fromIndex = index;
            const toIndex = directionUp ? index - 1 : index + 1;

            // Prevent out-of-bounds errors
            if (toIndex < 0 || toIndex >= taskTypes.length) return prevProject;

            // Get the product to move
            const productToMove = taskTypes[fromIndex].products[j];

            // Remove the product from the current task type
            const updatedFromProducts = [...taskTypes[fromIndex].products];
            updatedFromProducts.splice(j, 1);

            // Add the product to the new task type
            const updatedToProducts = [...taskTypes[toIndex].products, productToMove];

            // Clone the task types and update the from and to task types
            const updatedTaskTypes = [...taskTypes];
            updatedTaskTypes[fromIndex] = {
                ...taskTypes[fromIndex],
                products: updatedFromProducts,
            };
            updatedTaskTypes[toIndex] = {
                ...taskTypes[toIndex],
                products: updatedToProducts,
            };

            return {
                ...prevProject,
                taskTypes: updatedTaskTypes,
            };
        });
    };


    const addTaskTypeRow = () => {
        setProductProject((prev) => {
            const currentTaskTypes = prev?.taskTypes ?? [];
            const lastRow = currentTaskTypes[currentTaskTypes.length - 1];
            return {
                ...prev,
                taskTypes: [...currentTaskTypes, {index: lastRow ? lastRow.index + 1 : 1}]
            };
        });
    };

    const removeLastTaskTypeRow = () => {
        setProductProject((prev) => {
            const updatedTaskTypes = [...prev.taskTypes.slice(0, -1)];
            return {
                ...prev,
                taskTypes: updatedTaskTypes
            };
        });
    };

    const swapRecords = (index, otherIndex) => {
        setProductProject(prev => {
            const newTaskTypes = prev.taskTypes;
            const temp = newTaskTypes[index];
            newTaskTypes[index] = newTaskTypes[otherIndex];
            newTaskTypes[otherIndex] = temp;

            return {
                ...prev,
                taskTypes: newTaskTypes
            };
        });
    };

    const onTaskTypeChange = (itemIndex, newValue, field) => {
        setProductProject((prev) => {
            const updated = prev.taskTypes.map((item, index) => {
                if (index === itemIndex) {
                    return {...item, [field]: newValue};
                }
                return item;
            });

            return {
                ...prev,
                taskTypes: updated,
            };
        });
    }

    const changeProduct = (itemIndex, taskTypeIndex, newProduct) => {
        setProductProject((prev) => {
            const updatedTaskTypes = [...(prev.taskTypes || [])];
            const targetProducts = [...(updatedTaskTypes[itemIndex]?.products || [])];

            targetProducts[taskTypeIndex] = {
                ...targetProducts[taskTypeIndex],
                product: newProduct,
                unitPrice: newProduct.avgSellingPrice
            };

            updatedTaskTypes[itemIndex] = {
                ...updatedTaskTypes[itemIndex],
                products: targetProducts,
            };

            return {
                ...prev,
                taskTypes: updatedTaskTypes,
            };
        });
    };
    const onProductItemChange = (event, itemIndex, taskTypeIndex) => {
        const {name, value} = event.target;

        setProductProject((prev) => {
            const updatedTTPPs = [...prev.taskTypes];
            const updatedProducts = [...(updatedTTPPs[itemIndex]?.products || [])];

            updatedProducts[taskTypeIndex] = {
                ...updatedProducts[taskTypeIndex],
                [name]: value,
            };

            updatedTTPPs[itemIndex] = {
                ...updatedTTPPs[itemIndex],
                products: updatedProducts,
            };

            return {
                ...prev,
                taskTypes: updatedTTPPs,
            };
        });
    };

    const addProductRow = (itemIndex) => {
        setProductProject((prev) => {
            const updatedTTPPs = [...prev.taskTypes];
            const currentTaskTypes = [...(updatedTTPPs[itemIndex]?.products || [])];

            const newTask = {
                id: null,
                product: null,
                amount: 0,
                products: {id: updatedTTPPs[itemIndex].id},
                createdAt: null,
                updatedAt: null
            };

            currentTaskTypes.push(newTask);

            updatedTTPPs[itemIndex] = {
                ...updatedTTPPs[itemIndex],
                products: currentTaskTypes,
            };

            return {
                ...prev,
                taskTypes: updatedTTPPs,
            };
        });
    };

    const removeProductRow = (itemIndex, taskTypeIndex) => {
        setProductProject((prev) => {
            const updatedTTPPs = [...prev.taskTypes];
            const currentTaskTypes = [...(updatedTTPPs[itemIndex]?.products || [])];

            currentTaskTypes.splice(taskTypeIndex, 1); // remove the specific row

            updatedTTPPs[itemIndex] = {
                ...updatedTTPPs[itemIndex],
                products: currentTaskTypes,
            };

            return {
                ...prev,
                taskTypes: updatedTTPPs,
            };
        });
    };


    const onTaskTypeItemChange = (event, itemIndex) => {
        const {value, name} = event.target;
        setProductProject((prev) => {
            const updatedTaskTypes = prev.taskTypes.map((item, index) => {
                if (index === itemIndex) {
                    return {...item, [name]: value};
                }
                return item;
            });

            return {
                ...prev,
                taskTypes: updatedTaskTypes,
            };
        });
    };

    const changeProductSearchText = (value, itemIndex) => {
        productService.searchProductsSimple({page: 0, size: 10, searchText: value})
            .then(response => {
                setProductProject((prev) => {
                    const updated = (prev.taskTypes || [{}]).map((item, index) => {
                        if (index === itemIndex) {
                            return {...item, productList: response.content};
                        }
                        return item;
                    });

                    return {
                        ...prev,
                        taskTypes: updated,
                    };
                });
            })
            .catch(error => console.error(error))
    }

    const changeProductImage = (id, fileId) => {
        productProjectService.changeProductImage(id, fileId)
            .then(() => {
                sendAlertMessage('Termék projekt kép sikeresen beállítva')
                retrieveProductProject()
            })
            .catch(error => sendAlertMessage(error?.message || error, 'error'))
    }

    return (
        <ProductProjectEditorTemplate
            {...{
                id,
                productProject,
                message,
                onChange,
                create,
                update,
                navigate,
                waitingForServer,
                chatMessage,
                sendAlertMessage,
                changeProduct,
                onChangeChatMessage,
                onChangeCheckBox,
                onDateTimeChange,
                onTaskTypeChange,
                del,
                addTaskTypeRow,
                removeLastTaskTypeRow,
                onTaskTypeItemChange,
                removeDocumentName,
                updateFileDescription,
                handleFileChange,
                handleRemoveFile,
                files,
                swapRecords,
                taskTypes,
                changeProductSearchText,
                onProductItemChange,
                addProductRow,
                removeProductRow,
                convertExcelToProductList,
                moveProductToAnotherTaskType,
                saveAsDraft,
                deleteDraft,
                isDraft,
                imgUrl,
                loadingImage,
                changeProductImage
            }}
        />
    );
};

export default ProductProjectEditor;